module.exports = __webpack_public_path__ + "img/googlePlay.0dae3c20.png";